module.exports = __webpack_public_path__ + "img/banner3.79a0d38.png";